import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './TreeSearchSidebar.module.css';

import speechIcon from '../../Assets/icons/icon2.png';
import audioIcon from '../../Assets/icons/icon3.png';
import videoIcon from '../../Assets/icons/icon4.png';
import storyIcon from '../../Assets/icons/icon5.png';
import productionIcon from '../../Assets/icons/icon1.png';
import defaultImage from '../../Assets/speeches/v1_83.png';

const SearchSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasMoreResults, setHasMoreResults] = useState(false);
  const searchInputRef = useRef(null);

  let lang = localStorage.getItem('siteLanguage')
  let categoryConfig;

  // Category configuration
  if( lang === "fa") {
    categoryConfig = {
    speeches: {
      name: 'بيانات',
      icon: speechIcon,
      color: '#1a5f3f',
      route: '/speeches',
      apiCategory: 'speech'
    },
    audios: {
      name: 'فایل‌های صوتی',
      icon: audioIcon,
      color: '#2d7a4d',
      route: '/audios',
      apiCategory: 'audio'
    },
    stories: {
      name: 'ویدیوها',
      icon: storyIcon,
      color: '#0f4229',
      route: '/videos',
      apiCategory: 'video'
    },
    productions: {
      name: 'تولیدات',
      icon: productionIcon,
      color: '#1a5f3f',
      route: '/productions',
      apiCategory: 'production'
    }
  };
  }else {
    categoryConfig = {
    speeches: {
      name: 'خطابات',
      icon: speechIcon,
      color: '#1a5f3f',
      route: '/speeches',
      apiCategory: 'speech'
    },
    audios: {
      name: 'ملفات صوتیه',
      icon: audioIcon,
      color: '#2d7a4d',
      route: '/audios',
      apiCategory: 'audio'
    },
    stories: {
      name: 'فیدیوهات',
      icon: storyIcon,
      color: '#0f4229',
      route: '/videos',
      apiCategory: 'video'
    },
    productions: {
      name: 'انتاجات',
      icon: productionIcon,
      color: '#1a5f3f',
      route: '/productions',
      apiCategory: 'production'
    }
  };
  }

  const getCurrentCategory = () => {
    const path = location.pathname;
    if (path.includes('/speeches')) return 'speeches';
    if (path.includes('/audios')) return 'audios';
    if (path.includes('/stories')) return 'stories';
    if (path.includes('/productions')) return 'productions';
    return 'speeches'; 
  };

  const currentCategory = getCurrentCategory();
  const categoryInfo = categoryConfig[currentCategory];

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);

  // Search function
  const performSearch = async (term) => {
    if (!term.trim()) {
      setSearchResults([]);
      setHasMoreResults(false);
      return;
    }

    setLoading(true);
    try {
      const PickLanguage = localStorage.getItem('siteLanguage');
      let response;
      if (PickLanguage === "fa") {
           response = await fetch(
        `https://api.nasrollah.info/fa/?function=searchByCategory&params=${encodeURIComponent(term)}&category=${categoryInfo.apiCategory}`
      );
      }else {
         response = await fetch(
        `https://api.nasrollah.info/ar/?function=searchByCategory&params=${encodeURIComponent(term)}&category=${categoryInfo.apiCategory}`
      );
      }

      if (!response.ok) {
        throw new Error('خطا در جستجو');
      }

      const data = await response.json();
      const results = data || [];
      
      setSearchResults(results.slice(0, 5));
      setHasMoreResults(results.length > 5);
    } catch (error) {
      console.error('Search error:', error);
      setSearchResults([]);
      setHasMoreResults(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    
    if (value.trim()) {
      const timeoutId = setTimeout(() => {
        performSearch(value);
      }, 300);
      
      return () => clearTimeout(timeoutId);
    } else {
      setSearchResults([]);
      setHasMoreResults(false);
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      performSearch(searchTerm);
    }
  };

  const formatSlug = (slug) => {
    if (!slug) return '';
    return slug.replace(/\s+/g, '-');
  };

  const convertToPersianYear = (dateString) => {
    if (!dateString) return '';
    
    try {
      let date = new Date(dateString);
      
      if (isNaN(date.getTime())) {
        const yearMatch = dateString.match(/\d{4}/);
        if (yearMatch) {
          date = new Date(parseInt(yearMatch[0]), 0, 1);
        } else {
          return '';
        }
      }
      
      const gregorianYear = date.getFullYear();
      const gregorianMonth = date.getMonth() + 1;
      const gregorianDay = date.getDate();
      
      let persianYear;
      if (gregorianMonth < 3 || (gregorianMonth === 3 && gregorianDay < 21)) {
        persianYear = gregorianYear - 622;
      } else {
        persianYear = gregorianYear - 621;
      }
      
      return persianYear.toString();
    } catch (error) {
      console.error('Error converting to Persian year:', error);
      return '';
    }
  };

  const handleResultClick = (result) => {
    const formattedSlug = formatSlug(result.slug_post);
    const persianYear = convertToPersianYear(result.original_time_post);
    const route = `/${currentCategory}/${persianYear}/${formattedSlug}/${result.id_post}`;
    navigate(route);
  };

  // Handle view more
  const handleViewMore = () => {
    const searchPath = `/${currentCategory}/SearchByCategoryResult/${encodeURIComponent(searchTerm)}`;
    console.log(searchTerm)
    console.log(searchPath)
    navigate(searchPath);
  };
  let PickLanguage = localStorage.getItem("siteLanguage");
  if (PickLanguage === "fa") {
    return (
    <div className={styles.searchSidebar}>
      <div className={styles.sidebarHeader}>
        <h2 className={styles.sidebarTitle}>
          جستجو در {categoryInfo.name}
        </h2>
        <div className={styles.categoryIcon}>
          <img src={categoryInfo.icon} alt={categoryInfo.name} />
        </div>
      </div>

      {/* Search Form */}
      <form onSubmit={handleSearchSubmit} className={styles.searchForm}>
        <div className={styles.searchInputContainer}>
          <input
            ref={searchInputRef}
            type="text"
            value={searchTerm}
            onChange={handleSearchChange}
            placeholder="جستجو کنید..."
            className={styles.searchInput}
          />
          <button 
            type="submit" 
            className={styles.searchButton}
            style={{ backgroundColor: categoryInfo.color }}
          >
            🔍
          </button>
        </div>
      </form>

      {/* Search Results */}
      <div className={styles.searchResults}>
        {loading && (
          <div className={styles.loadingState}>
            <div className={styles.loadingSpinner}></div>
            <span>در حال جستجو...</span>
          </div>
        )}

        {!loading && searchTerm && searchResults.length === 0 && (
          <div className={styles.noResults}>
            <div className={styles.noResultsIcon}>🔍</div>
            <p>نتیجه‌ای یافت نشد</p>
            <small>کلمات کلیدی دیگری امتحان کنید</small>
          </div>
        )}

        {!loading && searchResults.length > 0 && (
          <>
            <div className={styles.resultsList}>
              {searchResults.map((result) => (
                <div
                  key={result.id_post}
                  className={styles.resultItem}
                  onClick={() => handleResultClick(result)}
                >
                  <div className={styles.resultImage}>
                    <img
                      src={result.featured_post}
                      alt={result.title_post}
                      onError={(e) => {
                        e.target.src = defaultImage;
                      }}
                    />
                    {/* <div className={styles.resultOverlay}>
                      <img
                        src={categoryInfo.icon}
                        alt={categoryInfo.name}
                        className={styles.resultIcon}
                      />
                    </div> */}
                  </div>
                  <div className={styles.resultContent}>
                    <h3 className={styles.resultTitle}>
                      {result.title_post}
                    </h3>
                    <div className={styles.resultMeta}>
                      <span className={styles.resultAuthor}>
                        {result.author_post}
                      </span>
                      <span className={styles.resultDate}>
                        {new Date(result.original_time_post).toLocaleDateString('fa-IR')}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {hasMoreResults && (
              <div className={styles.moreResultsSection}>
                <button 
                  className={styles.moreResultsButton}
                  onClick={handleViewMore}
                  style={{ backgroundColor: categoryInfo.color }}
                >
                  مشاهده همه نتایج
                  <span className={styles.moreResultsArrow}>←</span>
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
  }
  return (
    <div className={styles.searchSidebar}>
      <div className={styles.sidebarHeader}>
        <h2 className={styles.sidebarTitle}>
          البحث في {categoryInfo.name}
        </h2>
        <div className={styles.categoryIcon}>
          <img src={categoryInfo.icon} alt={categoryInfo.name} />
        </div>
      </div>

      {/* Search Form */}
      <form onSubmit={handleSearchSubmit} className={styles.searchForm}>
        <div className={styles.searchInputContainer}>
          <input
            ref={searchInputRef}
            type="text"
            value={searchTerm}
            onChange={handleSearchChange}
            placeholder="ابحث هنا..."
            className={styles.searchInput}
          />
          <button 
            type="submit" 
            className={styles.searchButton}
            style={{ backgroundColor: categoryInfo.color }}
          >
            🔍
          </button>
        </div>
      </form>

      {/* Search Results */}
      <div className={styles.searchResults}>
        {loading && (
          <div className={styles.loadingState}>
            <div className={styles.loadingSpinner}></div>
            <span>جاري البحث...</span>
          </div>
        )}

        {!loading && searchTerm && searchResults.length === 0 && (
          <div className={styles.noResults}>
            <div className={styles.noResultsIcon}>🔍</div>
            <p>لم يتم العثور على نتائج</p>
            <small>جرب كلمات مفتاحية أخرى</small>
          </div>
        )}

        {!loading && searchResults.length > 0 && (
          <>
            <div className={styles.resultsList}>
              {searchResults.map((result) => (
                <div
                  key={result.id_post}
                  className={styles.resultItem}
                  onClick={() => handleResultClick(result)}
                >
                  <div className={styles.resultImage}>
                    <img
                      src={result.featured_post}
                      alt={result.title_post}
                      onError={(e) => {
                        e.target.src = defaultImage;
                      }}
                    />
                    {/* <div className={styles.resultOverlay}>
                      <img
                        src={categoryInfo.icon}
                        alt={categoryInfo.name}
                        className={styles.resultIcon}
                      />
                    </div> */}
                  </div>
                  <div className={styles.resultContent}>
                    <h3 className={styles.resultTitle}>
                      {result.title_post}
                    </h3>
                    <div className={styles.resultMeta}>
                      <span className={styles.resultAuthor}>
                        {result.author_post}
                      </span>
                      <span className={styles.resultDate}>
                        {new Date(result.original_time_post).toLocaleDateString('ar-LB')}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {hasMoreResults && (
              <div className={styles.moreResultsSection}>
                <button 
                  className={styles.moreResultsButton}
                  onClick={handleViewMore}
                  style={{ backgroundColor: categoryInfo.color }}
                >
                  عرض جميع النتائج
                  <span className={styles.moreResultsArrow}>←</span>
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );

};

export default SearchSidebar;
